import React from 'react';
interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}
export function Label({
  children,
  className = '',
  required,
  ...props
}: LabelProps) {
  return <label className={`block text-xs sm:text-sm font-semibold text-stone-700 mb-1.5 print:text-xs print:mb-1 ${className}`} {...props} data-id="element-670">
      {children}
      {required && <span className="text-red-600 ml-0.5 print:hidden" data-id="element-671">*</span>}
    </label>;
}